import { creatorQueryKeys as e } from "./useCreatorQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { creatorApi as n } from "@maat/api-main";
//#region src/creator/useCreatorLinkQrQuery.ts
var r = (r) => t({
	queryKey: e.linkQr(r),
	queryFn: () => n.linkQr(r),
	enabled: !!r,
	staleTime: Infinity
});
//#endregion
export { r as useCreatorLinkQrQuery };
